import React from 'react';
import styled from 'styled-components';
import MapPointerIcon from "../Icons/MapPointerIcon";
import PhoneIcon from "../Icons/PhoneIcon";
import TollFreeIcon from "../Icons/TollFreeIcon";
import MailIcon from "../Icons/MailIcon";

const AddressListGrid = styled.div`
    position:relative;
    margin-bottom:15px;
`
const AddressGrid = styled.div`
    margin-top:20px;
    color:#fff;
    h3, a{color: #fff;}
    h3{
        margin-bottom:5px;
    }
`


const ItemAddress = styled.div`
    display:flex;
    flex-wrap:nowrap;
    margin:5px 0;
    .icon{
        display:flex;
        align-items:center;
        justify-content:center;
        height:26px;
        > svg{
            fill:#fff;
            width:18px;
            height:18px;
        }
        + .text{
            margin-left:20px;
        }		
    }
    .text{
        display:inline-flex;		
        line-height:26px;
    }	
`

const LocationGrid = ({ data }) => (
	<AddressListGrid className="address-list">
        <AddressGrid className="address-grid">
            <h3 className="h5">Lake City</h3>
            <ItemAddress className="item-address">
                <span className="icon"><MapPointerIcon /></span>
                <span className="text">
                    <a href="https://maps.app.goo.gl/Uy9Tda6jTpHv2kyF9" target="_blank" rel="noreferrer">792 SW Bascom Norris Drive, Lake City, FL 32025
                    </a>
                </span>
            </ItemAddress>
            <ItemAddress className="item-address">
                <span className="icon"><PhoneIcon /></span>
                <span className="text">
                    <a href="tel:3867556449">(386) 755-6449</a>
                </span>
            </ItemAddress>
            <ItemAddress className="item-address">
                <span className="icon"><MailIcon /></span>
                <span className="text">
                    <a href="mailto:Info@buildingandmore.com">Info@buildingandmore.com</a>
                </span>
            </ItemAddress>
        </AddressGrid>

        <AddressGrid className="address-grid">
            <h3 className="h5">Macclenny</h3>
            <ItemAddress className="item-address">
                <span className="icon"><MapPointerIcon /></span>
                <span className="text">
                    <a href="https://maps.app.goo.gl/o22iX8engdeS8rNy9" target="_blank" rel="noreferrer">1168 Macclenny Avenue West, Macclenny, FL 32063</a>
                </span>
            </ItemAddress>

            <ItemAddress className="item-address">
                <span className="icon"><PhoneIcon /></span>
                <span className="text">
                    <a href="tel:9042594054">(904) 259-4054</a>
                </span>
            </ItemAddress>
            <ItemAddress className="item-address">
                <span className="icon"><MailIcon /></span>
                <span className="text">
                    <a href="mailto:Info@buildingandmore.com">Info@buildingandmore.com</a>
                </span>
            </ItemAddress>
        </AddressGrid>

        <AddressGrid className="address-grid">
            <h3 className="h5">Starke</h3>
            <ItemAddress className="item-address">
                <span className="icon"><MapPointerIcon /></span>
                <span className="text">
                    <a href="https://maps.app.goo.gl/DqjPRWSU1aBzaJsR8" target="_blank" rel="noreferrer">1540 South Walnut Street, Starke, FL 32091</a>
                </span>
            </ItemAddress>								

            <ItemAddress className="item-address">
                <span className="icon"><PhoneIcon /></span>
                <span className="text">
                    <a href="tel:9049660077">(904) 966-0077</a>
                </span>
            </ItemAddress>								

            <ItemAddress className="item-address">
                <span className="icon"><TollFreeIcon /></span>                
                <span className="text">
                    <a href="tel:9042594054">Toll Free: (904) 259-4054</a>
                </span>
            </ItemAddress>								

            <ItemAddress className="item-address">
                <span className="icon"><MailIcon /></span>
                <span className="text">
                    <a href="mailto:Info@buildingandmore.com">Info@buildingandmore.com</a>
                </span>
            </ItemAddress>								

        </AddressGrid>
    </AddressListGrid>
)

export default LocationGrid